export const PAGE_TYPE = {
  FOLLOWING: 'following',
  FOLLOWERS: 'followers',
};
